import { useNavigate } from 'react-router-dom'

const iconMap = {
  code: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
    </svg>
  ),
  cloud: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
    </svg>
  ),
  brain: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
    </svg>
  ),
  integration: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
    </svg>
  ),
  default: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
    </svg>
  )
}

export default function ToolCard({ tool }) {
  const navigate = useNavigate()

  const handleCardClick = () => {
    navigate(`/tools/${tool._id}`)
  }

  const icon = iconMap[tool.icon] || iconMap.default

  return (
    <article 
      onClick={handleCardClick}
      className="border border-border-dark rounded-medium p-5 bg-white/[0.03] cursor-pointer hover:bg-white/[0.05] hover:border-accent-dark transition-all"
    >
      <div className="flex items-start gap-4 mb-3">
        <div className="text-accent-dark flex-shrink-0 mt-1">
          {icon}
        </div>
        <div className="flex-1">
          <div className="flex items-baseline justify-between gap-2 mb-2">
            <h3 className="text-lg leading-[1.25] tracking-[-0.01em] m-0 font-semibold">
              {tool.name}
            </h3>
            <span className="font-mono text-[10px] tracking-wide uppercase text-muted-dark bg-white/[0.02] px-2 py-1 rounded border border-border-dark whitespace-nowrap">
              {tool.category}
            </span>
          </div>
          <p className="m-0 text-muted-dark leading-[1.6] text-sm mb-3">
            {tool.description}
          </p>
        </div>
      </div>
      
      <div className="flex gap-3.5 flex-wrap font-mono text-xs tracking-[0.16em] uppercase">
        <span className="text-accent-dark font-semibold">
          View details →
        </span>
      </div>
    </article>
  )
}

